module.exports = __webpack_public_path__ + "img/section5Logo3.8cd7fe9d.svg";